<template>
  <div class="sign_up">
    <div id="head-page" class="inscription parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/montagnes-02.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/sapins-big.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/sapins-small.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="box-double hal white">
      <div class="box-mascotte">
        <img src="@/assets/images/mascotte/mascotte-blind.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
        <div class="box-eye">
          <div class="eventListener">1</div>
          <div class="eventListener">2</div>
          <div class="eventListener">3</div>
          <div class="eventListener">4</div>
          <div class="eventListener">5</div>
          <div class="eventListener">6</div>
          <div class="eventListener">7</div>
          <div class="eventListener">8</div>
          <div class="eventListener">9</div>
          <div class="eventListener">10</div>
          <div class="eventListener">11</div>
          <div class="eventListener">12</div>
          <div class="eventListener">13</div>
          <div class="eventListener">14</div>
          <div class="eventListener">15</div>
          <div class="eventListener">16</div>

        <div class="eye"></div>

        </div>
        <div class="bubble right txtleft" :class="{off: !bubble}">Cet espace vous permet de créer un compte pour votre enfant. Entrez les informations ci-dessous.<i class="bt_close fas fa-times-circle" @click="closeBubble"></i></div>
      </div>
    </div>

    <div class="grid-container content-page inscription">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-8 medium-offset-2 large-6 large-offset-3 cell">

          <div class="formulaire inscription">
            <div class="content">
              <div class="box-form">

                <h3 class="center">Créer un compte pour :</h3>

                <div class="line" :class="{'error': errors.indexOf('gender') !== -1}">
                  <div class="box-radio"><input type="radio" id="genre-m" name="genre" value="H" v-model="gender" ><label for="genre-m">Garçon</label></div>
                  <div class="box-radio"><input type="radio" id="genre-f" name="genre" value="F" v-model="gender" ><label for="genre-f">Fille</label></div>
                </div>
                </br>

                <div :class="{error: errors.indexOf('identifier') !== -1}">
                  <label for="identifier/">Identifiant/Pseudo enfant dans Globulo Quest * :</label>
                  <input type="text" name="identifier" id="identifier" v-model="identifier" required />
                </div>

                <div :class="{error: errors.indexOf('firstname') !== -1}">
                  <label for="prenom">Prénom* :</label>
                  <input type="text" name="prenom" id="prenom" v-model="first_name" required />
                </div>

                <div :class="{error: errors.indexOf('lastname') !== -1}">
                  <label for="nom">Nom de famille* :</label>
                  <input type="text" name="nom" id="nom" v-model="last_name" required />
                </div>

                <div :class="{error: errors.indexOf('birthdate') !== -1}">
                  <label for="date">Date de naissance* :</label>
                  <v-date-picker name="date" id="date" v-model="birthdate" />
                </div>

                <label for="email">Email</label>
                <input type="email" name="email" id="email" v-model="email" required />

                <div :class="{error: errors.indexOf('password') !== -1}">
                <label for="password">Mot de passe*</label>
                <input type="password" name="password" id="password" v-model="password" required />
                </div>

                <div :class="{'error password': errors.indexOf('password') !== -1}">
                  <label for="password-confirm">Confirmer mot de passe*</label>
                  <input type="password" name="password-confirm" id="password-confirm" v-model="password_confirmation" required />
                </div>

                </br>
                </br>
                <input class="button btnPush" name="submit" type="submit" value="Valider ce compte" @click="send" @mouseover="verify"/>
                </br>
                </br>
                <p><em>* Champs obligatoires</em></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Bouton from '@/components/Bouton'
  import { mapActions } from 'vuex'


  export default {
    components: { Bouton },
    data () {
      return {
        identifier: '',
        gender: '',
        birthdate: new Date(),
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        bubble: true,
        errors: []
      }
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
          // access to component instance via `vm`
          if(!vm.$store.state.subaccounts.child){
              next();
          } else {
            next({ name: 'dashboard' });
          }
      })
    },
    methods: {
      ...mapActions(['createChild']),
      closeBubble () {
        this.bubble = false;
      },
      verify (field) {
        this.errors = []
        if (!this.password || this.password !== this.password_confirmation) {
          this.errors.push("password")
        }
        if (!this.identifier) {
          this.errors.push("identifier")
        }
        if (!this.first_name) {
          this.errors.push("firstname")
        }
        if (!this.last_name) {
          this.errors.push("lastname")
        }
        if (!this.gender) {
          this.errors.push("gender")
        }
        if (!this.birthdate) {
          this.errors.push("birthdate")
        }
      },
      async send (e) {
        e.preventDefault();
        this.verify();
        if (this.errors.length > 0) {
          return false
        }

        try {
          let user = {
            identifier: this.identifier,
            password: this.password,
            first_name: this.first_name,
            last_name: this.last_name,
            gender: this.gender,
            birthdate: this.birthdate.toISOString().split('T')[0],
            email: this.email,
          }
          await this.createChild({ user });
          this.$router.push({name: 'post_child_sign_up'})
        } catch (ex) {
          console.log('error', ex);
        }
      }
    }
  }
</script>
